<template>
  <div>
    <header class="positionHeader ">
      <div style="padding-top: 10px;padding-left: 35px">{{newTime}}</div>
      <span class="positionHeaderS">推荐</span>
      <!--<a href="index.html" class="backlastpage"></a>-->
      <!--<h3>职位</h3>-->
      <!--<p>推荐</p>-->
      <!--<p>平面设计</p>-->
      <!--<p>ui设计</p>-->
    </header>
    <div class="positionMain" style="margin-top: 5.5rem;padding-bottom: 60px">
      <van-list
        v-model="isUpLoading"
        :finished="upFinished"
        :immediate-check="false"
        finished-text="没有更多了！！"
        @load="onLoad">
      <!--<router-link to="/detailsPosition">-->
        <div style="border-bottom: solid 1px #DEDEDE" v-for="(index,key) in list" @click="toPosition(index)">
          <div class="recommend">
            <div class="recommendTop">
              <span>{{index.jname}}</span>
              <span style="color: #07c160">{{index.salary}}</span>
            </div>
            <div class="recommendG">
              <span class="recommendYear">{{index.work_year}}</span>
              <span class="recommendYear">{{index.edu}}</span>
            </div>
            <div style="font-size: 13px" class="recommendTop" >
              <div>
                <span>{{index.cname}} </span>
                <span v-if="index.stage==1">{{index.stage}} </span>
                <span v-else-if="index.stage==1">不需要融资  </span>
                <span v-else-if="index.stage==2">天使  </span>
                <span v-else-if="index.stage==3">A轮  </span>
                <span v-else-if="index.stage==4">B轮  </span>
                <span v-else-if="index.stage==5">D轮  </span>
                <span v-else-if="index.stage==6">D轮及以上  </span>
                <span v-else-if="index.stage==7">上市公司  </span>
                <span v-if="index.scale==1">15人以下 </span>
                <span v-else-if="index.scale==2" >15-50 </span>
                <span v-else-if="index.scale==3" >50-150 </span>
                <span v-else-if="index.scale==4" >150-500  </span>
                <span v-else-if="index.scale==5" >500-2000 </span>
                <span v-else-if="index.scale==6" >2000人以上 </span>
              </div>
              <!--<div>朝阳区·高碑店</div>-->
            </div>
          </div>
        </div>
      </van-list>
      <!--</router-link>-->

    <!--<div style="border-bottom: solid 1px #DEDEDE">-->
      <!--<div class="recommend">-->
        <!--<div class="recommendTop">-->
          <!--<span>平面设计（活动、会展）</span>-->
          <!--<span>6-11k</span>-->
        <!--</div>-->
        <!--<div class="recommendG">-->
          <!--<span class="recommendYear">3-5年</span>-->
          <!--<span class="recommendYear">大专</span>-->
        <!--</div>-->
        <!--<div style="font-size: 13px" class="recommendTop" >-->
          <!--<div>-->
            <!--<span>XX公司 </span>-->
            <!--<span>未融资 </span>-->
            <!--<span>20-99人 </span>-->
          <!--</div>-->
          <!--<div>朝阳区·高碑店</div>-->
        <!--</div>-->
      <!--</div>-->
    <!--</div>-->
    </div>
    <van-tabbar route >
      <van-tabbar-item replace to="/" icon="wap-home-o">
        首页
      </van-tabbar-item>
      <van-tabbar-item replace to="/position" icon="envelop-o">
        职位
      </van-tabbar-item>
      <van-tabbar-item replace @click="href()" icon="fire-o">
        <!--<van-icon name="fire-o" />-->
        社保
      </van-tabbar-item>
      <van-tabbar-item replace to="/firstMessage" icon="desktop-o">
        消息
      </van-tabbar-item>
      <van-tabbar-item replace to="/HelloWorld" icon="contact">
        我的
      </van-tabbar-item>
    </van-tabbar>

  </div>
</template>

<script>
  const days = ['天', '一', '二', '三', '四', '五', '六']; // 星期数组
  var icnow = new Date();      // 初始化时间
  var interval;
  export default {
    name: 'position',
    data () {
      return {
        msg: '',
        list:[],
        year: icnow.getFullYear(),
        month: icnow.getMonth() + 1,
        date: icnow.getDate(),
        day: days[icnow.getDay() - 1],
        time: icnow.toTimeString().substring(0, 8),
        isUpLoading:false,
        upFinished:false,
        pageIndex:1,
        pageSize:10
      }
    },
    mounted(){
      this.getPositioner()
    },
    created () {
      interval = setInterval(() =>{
        let icnow = new Date();
        this.year = icnow.getFullYear();
        this.month = icnow.getMonth() + 1;
        this.date = icnow.getDate();
        this.day = days[icnow.getDay()];
        this.time = icnow.toTimeString().substring(0, 8);
      }, 1000)
    },
    computed: {
      // 当前时间
      newTime: function () {
//        return this.year + '年' + this.month + '月' + this.date + '日 星期' + this.day + ' ' + this.time;
        return this.month + '月' + this.date + '日' + this.time;
      }
    },
    beforeDestroy () {
      clearInterval(interval);
    },
    methods:{
      href(){
        window.location.href = 'https://m.shangshebao.com';
      },
      toPosition(index){
        this.$router.push({
          path:`/detailsPosition/${index.jid}/${index.cid}`
        })
      },
      getPositioner(){ //职位信息
        this.$api.getPosition({
          page:this.pageIndex
        })
          .then(res=>{
            const rows=res.data
            this.isUpLoading=false
            if(rows==null||rows.length===0){
              this.upFinished=true
              return
            }
            if(rows.length<this.pageSize){
              this.upFinished=true
            }
//            if(res.status==200){
              this.list=this.list.concat(rows)

//              this.id=res.data.id
//              console.log(this.data)
//            }
          })
      },
      onLoad(){
        this.pageIndex++
        setTimeout(() => {
          this.getPositioner()
        }, 2000);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
  @import '../assets/css/common.css';
  /*@import '../assets/css/header.css';*/
  @import '../assets/css/footer.css';
  .positionHeader{
    width: 100%;
    height: 5rem;
    background-color:#6e9bcf ;
    position: fixed;
    /*display: flex;*/
    top: 0;
    /*line-height: 3rem;*/
  }
  .positionHeaderS{
    padding: 10px 0 0 35px;
    display: block;
  }
  .positionHeader {
    /*margin-left: 1rem;*/
    color: #FFFFFF;
  }
  .recommend{
    /*margin-top:5  ;*/
    width: 80%;
    margin:0 auto 1.5rem;

  }
.recommendTop{
    display: flex;
    /*justify-content: space-around;*/
  padding-top: 0.8rem;
  justify-content: space-between;
  }
  .recommendG{
    padding-top: 0.8rem;
  }
  .recommendYear{
    background-color: #F5F4F3;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/position.vue